import { render } from "./TransactionsPage.vue?vue&type=template&id=5f033c13"
import script from "./TransactionsPage.vue?vue&type=script&lang=js"
export * from "./TransactionsPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TransactionsPage.vue?vue&type=style&index=0&id=5f033c13&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__